import React from 'react';

import {
  Input,
  Tooltip,
  Select,
  Checkbox,
  Button,
  Modal,
  notification,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import { graphql, compose } from 'react-apollo';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import crearUsuario from '../../../graphql/mutations/auth/crearUsuario.graphql';
import getUsuarios from '../../../graphql/querys/auth/getUsuarios.graphql';
import * as DeclaracionRoles from '../../common/DeclaracionRoles';
import { errorService } from '../../../graphql/utils/utils';

const FormItem = Form.Item;
const Option = Select.Option;

import _ from 'lodash';

@compose(
  graphql(getOrganismos),
  graphql(crearUsuario, {
    name: 'crearUsuario',
    options: {
      refetchQueries: [{ query: getUsuarios }],
    },
  })
)
class CrearUsuario extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
    };
  }

  handleOk = e => {
    console.log(e);

    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props
          .crearUsuario({
            variables: {
              username: values.username,
              activado: values.activado,
              rol: values.rol,
              idOrganismo: values.idOrganismo,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            // console.log("Insercion de usuario correcta");
            // console.log(res);
            notification.success({
              message: 'Creacion correcta',
              description:
                'Se ha registrado los datos del usuario correctamente',
            });

            this.props.history.push('/admin/usuarios');
          })
          .catch(err => {
            console.log('error en la creacion del usuario!!!');
            console.error(err);
            errorService(err, {
              username: values.username,
              activado: values.activado,
              rol: values.rol,
              idOrganismo: values.idOrganismo,
            });

            if (err.graphQLErrors[0].path[0] === 'crearUsuario') {
              Modal.error({
                title: 'Usuario inexistente',
                content:
                  'Por favor, compruebe que el usuario ingresado tenga un nombre de usuario valido y habilitado por el Poder Judicial de Neuquen',
              });
            } else {
              Modal.error({
                title: 'Error en la creacion del usuario ingresado',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            }
          });
      }
    });
  };
  handleCancel = e => {
    console.log(e);
    this.props.history.push('/admin/usuarios');
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  crearOpciones(organismo) {
    return (
      <Option key={organismo._id} value={organismo._id}>
        {organismo.nombre}
      </Option>
    );
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const listaOrganismos = this.props.data.getOrganismos;
    if (listaOrganismos) {
      var opcionesOrganismos = _.map(listaOrganismos, this.crearOpciones);
    }

    return (
      <div>
        <h1 className="tituloForm">Crear Usuario del Sistema</h1>
        <Form onSubmit={this.handleOk} className="formularios">
          <FormItem {...formItemLayout} label={<span>Nombre de usuario</span>}>
            {getFieldDecorator('username', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el nombre!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Activado</span>}>
            {getFieldDecorator('activado')(<Checkbox>Activado: </Checkbox>)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={<span>Rol del usuario en el sistema</span>}
          >
            {getFieldDecorator('rol', {
              initialValue: DeclaracionRoles.MESA_DE_ENTRADA,
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el rol!',
                  whitespace: true,
                },
              ],
            })(
              <Select style={{ width: '50%' }}>
                <Option value={DeclaracionRoles.MESA_DE_ENTRADA}>
                  {DeclaracionRoles.MESA_DE_ENTRADA}
                </Option>
                <Option value={DeclaracionRoles.DESPACHO}>
                  {DeclaracionRoles.DESPACHO}
                </Option>
                <Option value={DeclaracionRoles.FUNCIONARIO}>
                  {DeclaracionRoles.FUNCIONARIO}
                </Option>

                <Option value={DeclaracionRoles.OPERADOR}>
                  {DeclaracionRoles.OPERADOR}
                </Option>
                <Option value={DeclaracionRoles.ADMINISTRADOR}>
                  {DeclaracionRoles.ADMINISTRADOR}
                </Option>

                <Option value={DeclaracionRoles.CONFIGURACION}>
                  {DeclaracionRoles.CONFIGURACION}
                </Option>
                <Option value={DeclaracionRoles.SUPERVISOR}>
                  {DeclaracionRoles.SUPERVISOR}
                </Option>
                <Option value={DeclaracionRoles.DGJP_DIRECTOR}>
                  {DeclaracionRoles.DGJP_DIRECTOR}
                </Option>
                <Option value={DeclaracionRoles.DGJP_EMPLEADO}>
                  {DeclaracionRoles.DGJP_EMPLEADO}
                </Option>
                <Option value={DeclaracionRoles.SUELDOS}>
                  {DeclaracionRoles.SUELDOS}
                </Option>
                <Option value={DeclaracionRoles.GESTION_HUMANA}>
                  {DeclaracionRoles.GESTION_HUMANA}
                </Option>
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Organismo donde trabaja
                <Tooltip title="Seleccione el organismo donde trabaja este usuario">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idOrganismo', {
              rules: [
                { required: true, message: 'Por favor, ingrese el organismo!' },
              ],
            })(
              <Select
                showSearch
                style={{ width: 500 }}
                placeholder="Seleccione un organismo"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {opcionesOrganismos}
              </Select>
            )}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Confirmar
            </Button>
            <Button type="danger" onClick={this.handleCancel}>
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(CrearUsuario);
